export const HelpImages = {
  questionIcon: require('./questionIcon.svg'),
  sendIcon: require('./send.svg'),
  editIcon: require('./edit.svg'),
  searchIcon: require('./search.svg'),
  successIcon: require('./successNote.svg'),
  forwardArrowIcon: require('./forwardArrow.svg'),
  backArrowIcon: require('./backArrow.svg'),
};
